// extracted by mini-css-extract-plugin
export default {"actionBox":"CreateDocumentEntry_actionBox__5BWx3","canDrop":"CreateDocumentEntry_canDrop__4wfvr","dropzoneActive":"CreateDocumentEntry_dropzoneActive__14ZDx"};